<div class="icon">
  @if (shape !== undefined) {
    <app-icon [shape]="shape" [ngClass]="checked ? 'checked' : ''"></app-icon>
  }
</div>
<div class="label" [innerHtml]="label"></div>
